import React from 'react'
import PropTypes from 'prop-types'
import { Table } from 'reactstrap'
import CustomerRefundVoucherTableRow from './customer-refund-voucher-table-row'
import withLoader from 'hocs/with-loader'
import { CardLoader, ListPagination } from 'components/organisms'
const propTypes = {
  tableProps     : PropTypes.object,
  refundVouchers : PropTypes.Array,
  pagination     : PropTypes.object,
  isLoading      : PropTypes.bool,
  onClickRow     : PropTypes.func,
  onPageChange   : PropTypes.func
}

const defaultProps = {
  refundVouchers : [],
  isLoading      : false,
  onClickRow     : () => {},
  data           : [],
  pagination     : {},
  onPageChange   : () => {}
}

/**
 * Table to display Customer refund voucher columns
 * @param {Object} tableProps - object of tableProps that contains size, responsive, etc
 * @param {Array<Object>} refundVouchers - array of customer-refund-vouchers objects
 * @param {Object} pagination - object of pagination data from endpoint
 * @param {Boolean} isLoading - whether the table is currently loading data from the backend
 * @param {Function} onClickRow - function that will be used in the action Button
 */
const CustomerRefundVoucherTable = ({
  tableProps,
  refundVouchers,
  pagination,
  isLoading,
  onPageChange,
  onClickRow
}) => {
  const TableContent = () => {
    const isRefundVouchersEmpty = refundVouchers.length === 0
    return (
      <Table { ...tableProps }>
        <thead>
          <tr>
            <th colSpan={ 4 }>{ 'Order Number' }</th>
            <th colSpan={ 4 }>{ 'Customer Name' }</th>
            <th colSpan={ 4 }>{ 'Voucher Status' }</th>
          </tr>
        </thead>
        <tbody>
          {
            refundVouchers.map((refundVoucher) => (
              <CustomerRefundVoucherTableRow
                key={ `customer-refund-voucher-row-${refundVoucher.id}` }
                refundVoucher={ refundVoucher }
                onClickRow={ onClickRow }
              />
            ))
          }
          {
            isRefundVouchersEmpty && (
              <tr>
                <td
                  colSpan={ 12 }
                  className='bg-warning text-white'
                >
                  <i className='fas fa-info-circle mr-3' />
                  { 'Customer Order tidak ditemukan.' }
                </td>
              </tr>
            )
          }
        </tbody>
      </Table>
    )
  }
  const TableContentWithLoader = withLoader(TableContent, CardLoader)

  return (
    <>
      <TableContentWithLoader isLoading= { isLoading } />

      <ListPagination
        onClickPage={ onPageChange }
        pagination={ pagination }
      />
    </>
  )
}
CustomerRefundVoucherTable.propTypes    = propTypes
CustomerRefundVoucherTable.defaultProps = defaultProps

export default CustomerRefundVoucherTable